module.exports = __webpack_public_path__ + "img/b2dad9c.png";